var version = {
    "name":      "dativery",
    "buildDateCode": "20260119-092312",
    "buildDate": "Mon Jan 19 2026 09:23:12 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260119-092312",
    "backupUIVersion": "2.2.0-20250519-102244"
}
;
 export default version;